import { IAdditionalField } from "../../Orchestrator/Types/Interface/IServiceRequest";
import { countries } from "./countries";

export const EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}$/;

export const isEmailField = (field: IAdditionalField): boolean => {
    if (field.type !== "TEXT") return false;
    const hasTags = field.tags && Array.isArray(field.tags) && field.tags.includes("EMAIL");
    return hasTags || field.title === "EMAIL";
};

// isValidEmail runs a regex on every render for every EMAIL field. For a typical form with 1-2 such fields this is negligible,
// but if performance becomes a concern, consider debouncing or memoizing.
export const isValidEmail = (value: string): boolean => {
    return EMAIL_REGEX.test(value.trim());
};

// isValidMobile calls countries.find() on every render for every MOBILE field.
// For a typical form this is fine, but could be optimized with a lookup map if needed.
export const isValidMobile = (value: string, countryCode: string): boolean => {
    const country = countries.find((c) => c.countryCallingCode === countryCode);
    if (!country) return false;
    const digits = value.replace(/\D/g, "");
    return digits.length === country.phoneLength;
};

// Shared between CheckRequiredValidationAction (server-side gate) and the
// GroupBookingForm inline error display, so both apply the same rule.
// Accepts Unicode letters (Arabic transliteration, accented Latin),
// combining marks, spaces, apostrophes, and hyphens — UAE booking forms see
// names like Al-Khalifa, O'Brien, José regularly. \p{L} = any letter in any
// script; \p{M} keeps combining accents so decomposed (NFD) input like "Léa"
// (e + ´) isn't stripped down to "Lea".
export const NAME_REGEX = /^[\p{L}\p{M}\s'-]+$/u;
export const isValidName = (value: string): boolean => {
    const trimmed = value.trim();
    return trimmed.length >= 2 && trimmed.length <= 50 && NAME_REGEX.test(trimmed);
};
